import { computed, toRefs, ref, watchEffect } from "vue";
import { isNumber } from "../../../_utils/is.js";
const DEFAULT_HEIGHT = 200;
function useViewportHeight(props) {
  const { height } = toRefs(props);
  const viewportHeight = ref(DEFAULT_HEIGHT);
  const setViewportHeight = (val) => {
    viewportHeight.value = val;
  };
  watchEffect(() => {
    if (isNumber(height.value)) {
      viewportHeight.value = height.value;
    }
  });
  return {
    viewportHeight,
    setViewportHeight,
    needMeasureViewportHeight: computed(() => !isNumber(height.value))
  };
}
export { useViewportHeight };
